<template>
  <div class="table-form table-responsive">
    <table class="table">
      <thead>
      <tr>
        <th scope="col">Tutar</th>
        <th scope="col">Tarih</th>
        <th scope="col">Tipi</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="transaction in transactionList" :key="transaction.id">
        <th scope="row">{{ transaction.amount }} €</th>
        <th>{{ transaction.date | ddMMyyyyHHmm}} </th>
        <th v-if="transaction.type === 'SPEND'"><span class="badge badge-warning py-1 px-2"> SPEND </span></th>
        <th v-else-if="transaction.type === 'DEPOSIT'"><span class="badge badge-success py-1 px-2"> DEPOSIT </span></th>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "AgencyTransactionList",
  computed:{
    transactionList:{
      get(){
        return this.$store.getters.getTransactionList;
      }
    }
  },
}
</script>

<style scoped>
.table-form thead th {
  background-color: white;
  color: #1976d2;
}

.theme-btn{
  color: white!important;
}
</style>